import { ErrorBoundary } from "@circle-react-shared/ErrorBoundary";

import { CommentsContainer } from "@/react/components/CommentsCompass/CommentsContainer";
import { CommentsErrorFallback } from "@/react/components/CommentsCompass/CommentsErrorFallback";
import { useCommentsConfig } from "@/react/components/CommentsCompass/Provider/ConfigContext";
import { useCommentsSection } from "@/react/components/CommentsCompass/Provider/SectionContext";
import { useCommentsDeepLink } from "@/react/components/CommentsCompass/Provider/useCommentsDeepLink";
import { classNames } from "@/react/helpers/twMergeWithCN";

import { ComposerForm } from "./ComposerForm";

export interface ComposerProps {
  className?: string;
  isCollapsible?: boolean;
}

export const Composer = ({
  className,
  isCollapsible = false,
}: ComposerProps) => {
  const { canCompose } = useCommentsConfig();
  const { deepLinkedCommentId } = useCommentsDeepLink();
  const { clearComposerFocusRequest, isTopLevelFocusPending } =
    useCommentsSection();

  if (!canCompose || deepLinkedCommentId) return null;

  return (
    <ErrorBoundary name="CommentComposer" fallback={CommentsErrorFallback}>
      <div
        className={classNames("bg-primary sticky bottom-0 lg:py-5", className)}
      >
        <CommentsContainer>
          <ComposerForm
            isCollapsible={isCollapsible}
            isFocusPending={isTopLevelFocusPending}
            onFocusHandled={clearComposerFocusRequest}
          />
        </CommentsContainer>
      </div>
    </ErrorBoundary>
  );
};
